<script>
    import { tour } from '../tour';

    /* ____________ Mobile Detection ____________ */
    import UA from 'ua-parser-js';
    const ua = new UA();
    let isMobile = ua.getResult().device['type'] == 'mobile';

    
    export let scene = tour.getFirstSceneName();
    export let text;
    export let x = 0;
    export let y = 0;
    export let width = 120;
    export let opacity = 1;

    /**
     * Uses canvas.measureText to compute and return the width of the given text of given font in pixels.
     * 
     * @param {String} text The text to be rendered.
     * @param {String} font The css font descriptor that text is to be rendered with (e.g. "bold 14px verdana").
     * 
     * @see https://stackoverflow.com/questions/118241/calculate-text-width-with-javascript/21015393#21015393
     */
    function getTextWidth(text, font) {
        // re-use canvas object for better performance
        const canvas = getTextWidth.canvas || (getTextWidth.canvas = document.createElement("canvas"));
        const context = canvas.getContext("2d");
        context.font = font;
        const metrics = context.measureText(text);
        return metrics.width;
    }

    // ensure the width is not smaller than the content (text + arrow)
    let contentWidth = getTextWidth(text, '300 1.4rem Oswald') + 20;
    
    if(width < contentWidth){
        let newWidth = contentWidth + 10;
        // adjust x position to center the button on new width
        x = x - (newWidth - width) / 2;
        width = newWidth
    }
    
    function loadScene(){
        console.log(scene);
        tour.loadScene(scene);
    }

    let currentScene = tour.currentScene.getName();
    addEventListener('krpano:newpano', () => {
        currentScene = tour.currentScene.getName();
    });

    // set styles last
    let style = `
        top: ${y}px; 
        left: ${x}px; 
        opacity: ${opacity};
        width: ${width}px;
        `
    
    // set background to solid if we are using layer opacity
    if(opacity !== 1){
        style += `
        background: rgb(var(--scene-button-bg-color-rgb));
        `
    }
</script>

<style>
    :root {
        --scene-button-bg-color-rgb: var(--theme-color-rgb);
        --scene-button-hover-bg-color-rgb: var(--theme-color-rgb);
    }

    div {
        position: absolute;
        z-index: 999;

        border: 3px solid transparent;
        border-radius: 3px;
        padding: 8px;

        font-size: 1.4rem;
        font-family: Oswald, sans-serif; 
        font-weight: 300;
        color: #fff;
        
        background: rgba(var(--scene-button-bg-color-rgb) , 0.8);

        text-align: center;
        box-sizing: border-box;
        
        display: flex;
        align-items: center;
        justify-content: center;

        line-height: 1;
    }

    .back-arrow {
        width: 0.75em;
        height: auto;
        margin-right: 5px;
    }

    /* div.gradient {
        background: var(--scene-button-bg-color);
        background: -webkit-radial-gradient(center, var(--scene-button-bg-color), var(--scene-button-bg-color-2));
        background: -moz-radial-gradient(center, var(--scene-button-bg-color), var(--scene-button-bg-color-2));
        background: radial-gradient(ellipse at center, var(--scene-button-bg-color), var(--scene-button-bg-color-2));
    } */

    div:hover {
        cursor: pointer;
        background: rgb(var(--scene-button-hover-bg-color-rgb));
        border: 3px solid #fff;
    }

    /* mobile media query */
    @media (max-width: 768px) {
        div {
            font-size: 1.1rem;
        }

        div:hover {
            border: none;
        }
    }

</style>

{#if currentScene != scene}
<div class="no-select" style={style} on:click="{loadScene}">
    <img class="back-arrow" src="./images/back_arrow.png" alt="Back to"/> {text}
</div>
{/if}